/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'x-purple': {
    width: 16,
    height: 17,
    viewBox: '0 0 16 17',
    data:
      '<path pid="0" d="M11.693 1.771h2.146l-4.69 5.93 5.518 8.07h-4.32l-3.384-4.894-3.872 4.894H.943L5.96 9.428.667 1.771h4.43l3.058 4.474 3.538-4.474zm-.754 12.579h1.19L4.45 3.118H3.174l7.765 11.232z" _fill="#A363FF"/>'
  }
})
